const { API_URL } = window.__env__

export const env = {
  apiUrl: API_URL,
}